import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  getAllPaymentProviders,
} from "../../../redux/payment/paymentActions";
import errorHandler from '../../../handlers/errorHandler';

export default React.forwardRef(function OpayPlugin(
  { email, amount, onSuccess, onClose, reference, payment_type, cancelUrl, returnUrl, onOpen },
  ref
) {
  const dispatch = useDispatch();
  const { allProviders } = useSelector((state) => state.payment);
  const publicKey = allProviders?.opay_key;

  console.log('Opay component mounted', { ref, allProviders });

  useEffect(() => {
    dispatch(getAllPaymentProviders());
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(ref, () => {
    console.log('Opay useImperativeHandle setting up ref');
    return {
      getAmount_Reference: (amount, reference) => {
        console.log('Opay getAmount_Reference called', { amount, reference });
        initializePayment(amount, reference);
      },
    };
  });


  const initializePayment = async (paymentAmount, paymentReference) => {
    // Generate a fresh unique reference ID to prevent duplicate order errors
    const uniqueRef = paymentReference;

    // Calculate amount in major units (multiply by 100 for OPay)
    const amountInMajorUnits = Math.round((paymentAmount || amount) * 100).toString();

    const cancelLink = window.location.origin + cancelUrl;
    const returnLink = window.location.origin + returnUrl;

    // Build the exact payload object
    const payload = {
      amount: {
        currency: "NGN",
        total: amountInMajorUnits // OPay uses major units
      },
      callbackUrl: returnLink,
      country: "NG",
      expireAt: 15,
      merchantName: "Ogwugo Limited",
      product: {
        description: payment_type || "Payment",
        name: payment_type || "Order Payment"
      },
      reference: uniqueRef,
      returnUrl: returnLink,
      cancelUrl: cancelLink,
      userInfo: {
        userEmail: email || "customer@example.com",
        userName: "Customer"
      },
      payMethod: "BankTransfer",
    };

    // OPay API endpoints
    const sandboxApiUrl = "https://sandboxapi.opaycheckout.com/api/v1/international/cashier/create";
    const stagingApiUrl = "https://testapi.opaycheckout.com/api/v1/international/cashier/create";
    const liveApiUrl = "https://api.opaycheckout.com/api/v1/international/cashier/create";
    const proxyUrl = "https://vercel-proxy-cyan-seven.vercel.app/api/proxy";

    // Determine API URL based on environment
    const apiUrl = process.env.NODE_ENV === "development"
      ? sandboxApiUrl
      : (process.env.REACT_APP_APP_ENV === "staging" ? stagingApiUrl : liveApiUrl);

    // Use proxy for production/staging to avoid CORS
    const shouldUseProxy = process.env.NODE_ENV !== "development";

    try {
      let response;

      if (shouldUseProxy) {
        // Use proxy server for production/staging
        response = await axios.post(proxyUrl, {
          url: apiUrl,
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "MerchantId": allProviders?.opay_merchant_id,
            "Authorization": `Bearer ${publicKey}`
          },
          body: payload
        }, {
          headers: {
            "Content-Type": "application/json"
          }
        });
      } else {
        // Direct API call for development (may have CORS issues)
        response = await axios.post(apiUrl, payload, {
          headers: {
            "Content-Type": "application/json",
            "MerchantId": allProviders?.opay_merchant_id,
            "Authorization": `Bearer ${publicKey}`
          }
        });
      }

      const result = response.data;

      if (result.code === "00000" && result.data?.cashierUrl) {
        // Automatically open the cashier checkout screen in a new tab
        window.open(result.data.cashierUrl, '_blank');

        // Call onOpen callback to notify parent that portal has opened
        if (onOpen && typeof onOpen === 'function') {
          onOpen();
        }

        // Don't call onSuccessFunction here - wait for user to complete payment
        // The user will return via returnUrl after payment
      } else {
        console.error(`%c[OPay Error ${result.code}]: ${result.message}`, "color: red; font-weight: bold;");
        errorHandler({ response }, true);
        
        // Call onClose to notify parent that initialization failed
        if (onClose && typeof onClose === 'function') {
          onClose();
        }
      }
    } catch (error) {
      console.error("%c[Network Error] Request failed completely:", "color: red; font-weight: bold;");
      console.error(error);
      errorHandler(error, true);
      
      // Call onClose to notify parent that initialization failed
      if (onClose && typeof onClose === 'function') {
        onClose();
      }
    }
  };
});
